var utgs = {

	init: function() {

		this.hamburger();
		this.svgChangeGradient();
		this.initScrollEvents();
		this.initSticky(window.scrollY);
		if($('.gallery').length) this.initPopups();
		// if($('#main').outerHeight() < $('#subnav').outerHeight()) $('#main').css({'min-height': $('#subnav').outerHeight()});

	},
	hamburger: function() {

		var hamburger = $(".hamburger");
		var mainnav = $('#mainnavigation');	
		hamburger.on('click', function () {
			hamburger.toggleClass("is-active");
			mainnav.toggleClass("in");
		});

	},
	svgChangeGradient: function() {

		var header = $('#mainhead');
		var activeGradientId = ($('.gradientchange.active').length) ? $('.gradientchange.active').data('gradid') : 1;
		// header.attr('class', 'url(#grad-' + activeGradientId + ')');;

		$('.gradientchange').on('click', function(e){
			// move Gradient if sticky header
			var gradientID = $(this).data('gradid');
			// header.attr('class', header.attr('class').replace('-\d*', '-' + gradientID));
			header.attr('class', 'grad-' + gradientID);
		});

	},

	initSticky: function(lastScrollY) {

		if(!utgs.offset) utgs.offset = $('#mainhead').offset().top;
		// var sticky = $('body').hasClass('sticky');
		// var sticky = $('#mainhead').offset();
		// console.log(utgs.offset);
		if(lastScrollY > 50/*utgs.offset && !utgs.offset*/) {
			$('body').addClass('sticky');
			// console.log('sticky added');
		} else {
			$('body').removeClass('sticky');
			// console.log('sticky removed');
		}

	},

	initPopups: function() {

		$('.gallery').magnificPopup({
			delegate: 'a',
			type: 'image',
			gallery: {
				enabled: true
			}
		});

	},

	initScrollEvents: function() {

		var lastScrollY = 0;
		// var winHeight = 0;
		var ticking = false;

		var update = function() {
			// do your stuff
			// console.log(lastScrollY);
			utgs.initSticky(lastScrollY);


			ticking = false;
		};

		var requestTick = function() {
			if (!ticking) {
				window.requestAnimationFrame(update);
				ticking = true;
			}
		};

		var onScroll = function() {
			lastScrollY = window.scrollY;
			window.oldScrollY = lastScrollY;
			// winHeight = window.innerHeight;
			requestTick();
		};

		$(window).on('scroll', onScroll);

}


}
$( document ).ready(function() {

	utgs.init();  

});
